export default __webpack_public_path__ + "static/media/fold_title.634cfef8.png";